import { useDSTMetaInfoStore } from '@stores/dst/dstStore';
import { useRef } from 'react';

const useSetMetaInfo = ({ quizInfo, classPreference, attemptsInfo }) => {
  const ref = useRef(true);
  const { setInitialDSTInfo } = useDSTMetaInfoStore();

  if (ref.current) {
    setInitialDSTInfo({
      quizInfo,
      classPreference,
      attemptsInfo
    });
    ref.current = false;
  }
};

export default useSetMetaInfo;
